module.exports = __webpack_public_path__ + "static/media/liveIcon.a81068fb.svg";